
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole" [ngClass]="{'general-disabled':project.isMigrationActive}">
  <div class="row mt-2">
    <div class="col-12">
      <success #success></success>
    </div>
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Enter project details:</p>
      </div>
    </div>
  </div>
  <form #projectForm="ngForm">
    <div class="row justify-content-md-center">
      <div class="col-md-10 card-block">
        <div class="form-group">
          <label class="required" for="name">Name:</label>
          <input class="form-control" id="name" type="text" [(ngModel)]="project.name" name="projectName" maxlength="100" required>
          <validation-error-display [error]="error" field="projectName"></validation-error-display>
        </div>
        <div class="row">
          <div class="form-group col-lg-6">
            <label class="required">Country:</label>
            <select-country [inputId]="'country'" [(ngModel)]="project.countryId" name="countryIdWrapper" [inputName]="'countryId'" [disabled]="project.totalDevices &gt; 0" [geoRegionId]="project.geo_region_id" [error]="error"></select-country>
          </div>
          <div class="form-group col-lg-6">
            <label class="required">Status:</label>
            <select class="form-control" [(ngModel)]="project.status" name="status" required>
              <option value="open">Open</option>
              <option value="closed">Closed</option>
              <option value="hold">On Hold</option>
            </select>
            <validation-error-display [error]="error" field="status"></validation-error-display>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-12">
            <label class="required" for="sourceDocumentationLink">Source Documentation Link (DealSource or MAD)</label>
            <input class="form-control" id="sourceDocumentationLink" [(ngModel)]="project.sourceDocumentationLink" name="sourceDocumentationLink" type="text" required>
            <validation-error-display [error]="error" field="sourceDocumentationLink"></validation-error-display>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-6">
            <div class="inline-block">
              <label class="required" for="startDate">Start Date:
                <help-dialog-button fieldName="Start Date" helpString="The approved project start date (typically requires contract signature)"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="startDate" [(ngModel)]="project.startDate" name="startDate" type="text" required>
              <datepicker class="right input-group-append" [(ngModel)]="project.startDate" name="startDateSelector" (outputEvents)="startDateChange($event)" required></datepicker>
              <validation-error-display [error]="error" field="startDate"></validation-error-display>
            </div>
          </div>
          <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
            <div class="inline-block">
              <label class="required" for="completionDate">Estimated Completion Date:
                <help-dialog-button fieldName="Estimated Completion Date" helpString="The estimated date that all deployment deliverables will be completed for this customer project"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="completionDate" [(ngModel)]="project.estimatedCompletionDate" name="estimatedCompletionDate" type="text" required>
              <datepicker class="right input-group-append" [(ngModel)]="project.estimatedCompletionDate" name="estimatedCompletionDateSelector" [options]="completionDateOptions" required></datepicker>
              <validation-error-display [error]="error" field="estimatedCompletionDate"></validation-error-display>
            </div>
          </div>
          <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
            <label for="firstInstallDate">First Install Date</label>
            <input class="form-control disabled-content" id="firstInstallDate" [(ngModel)]="project.firstInstallDate" name="firstInstallDate" type="text">
          </div>
          <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
            <label for="firstOrderDate">First Order Date</label>
            <input class="form-control disabled-content" id="firstOrderDate" [(ngModel)]="project.firstOrderDate" name="firstOrderDate" type="text">
          </div>
          <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
            <div class="inline-block">
              <label class="required" for="customerKickoffDate">Customer Kickoff Date:</label>
            </div>
            <div class="input-group">
              <input class="form-control" id="customerKickoffDate" [(ngModel)]="project.customerKickoffDate" name="customerKickoffDate" type="text" required>
              <datepicker class="right input-group-append" [(ngModel)]="project.customerKickoffDate" name="customerKickoffDateSelector" [options]="completionDateOptions" required></datepicker>
              <validation-error-display [error]="error" field="customerKickoffDate"></validation-error-display>
            </div>
          </div>
          <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
            <div class="inline-block">
              <label class="required" for="estimatedProjectClosureDate">Estimated Project Closure Date:</label>
            </div>
            <div class="input-group">
              <input class="form-control" id="estimatedProjectClosureDate" [(ngModel)]="project.estimatedProjectClosureDate" name="estimatedProjectClosureDate" type="text" required>
              <datepicker class="right input-group-append" [(ngModel)]="project.estimatedProjectClosureDate" name="estimatedProjectClosureDateSelector" [options]="completionDateOptions" required></datepicker>
              <validation-error-display [error]="error" field="estimatedProjectClosureDate"></validation-error-display>
            </div>
          </div>
          <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
            <div class="inline-block">
              <label for="actualProjectClosureDate" [ngClass]="{required: project.status === 'closed'}">Actual Project Closure:</label>
            </div>
            <div class="input-group">
              <input class="form-control" id="actualProjectClosureDate" [(ngModel)]="project.actualProjectClosureDate" name="actualProjectClosureDate" type="text" required>
              <datepicker class="right input-group-append" [(ngModel)]="project.actualProjectClosureDate" name="actualProjectClosureDateSelector" [options]="completionDateOptions" required></datepicker>
              <validation-error-display [error]="error" field="actualProjectClosureDate"></validation-error-display>
            </div>
          </div>
        </div>
        <div class="row" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
          <div class="form-group col-lg-6">
            <label for="estimatedTransitionDate">Estimated Transition (months)</label>
            <input class="form-control" id="estimatedTransitionDate" [(ngModel)]="project.estimatedTransitionDate" name="estimatedTransitionDate" type="number" readonly>
            <validation-error-display [error]="error" field="estimatedTransitionDate"></validation-error-display>
          </div>
          <div class="form-group col-lg-6">
            <label for="actualTransitionDate">Actual Transition (months)</label>
            <input class="form-control" id="actualTransitionDate" [(ngModel)]="project.actualTransitionDate" name="actualTransitionDate" type="number" readonly>
            <validation-error-display [error]="error" field="actualTransitionDate"></validation-error-display>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-6">
            <label for="totalCustomerValue">Total Customer Value (USD)</label>
            <input class="form-control" id="totalCustomerValue" [(ngModel)]="project.totalCustomerValue" name="totalCustomerValue" type="number">
            <validation-error-display [error]="error" field="totalCustomerValue"></validation-error-display>
          </div>
          <div class="form-group col-lg-6">
            <label>Require MAI Pagecounts</label>
            <select class="form-control" type="text" [(ngModel)]="project.requireMaiPagecounts" name="requireMaiPagecounts">
              <option></option>
              <option [ngValue]="true">Yes</option>
              <option [ngValue]="false">No</option>
            </select>
            <validation-error-display [error]="error" field="requireMaiPagecounts"></validation-error-display>
          </div>
          <div class="form-group col-lg-6" id="currency">
            <label>Currency:</label>
            <select class="form-control" [(ngModel)]="project.currency" name="currency">
              <option value=""></option>
              <option *ngFor="let code of currencyCodes" [value]="code">{{ code }}</option>
            </select>
            <validation-error-display [error]="error" field="currency"></validation-error-display>
          </div>
          <div class="form-group col-lg-6">
            <label for="customerPin">Customer PIN</label>
            <input class="form-control" id="customerPin" [(ngModel)]="project.customerPin" name="customerPin" type="text" maxlength="20">
            <validation-error-display [error]="error" field="customerPin"></validation-error-display>
          </div>
          <div class="form-group col-lg-6">
            <label for="sourceName">Source Name</label>
            <input class="form-control" id="sourceName" [(ngModel)]="project.sourceName" name="sourceName" type="text" maxlength="60">
            <validation-error-display [error]="error" field="sourceName"></validation-error-display>
          </div>
          <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
            <label for="smartsheetWorkspace">Smartsheet Workspace ID</label>
            <div class="input-group">
              <input class="form-control" id="smartsheetWorkspace" [(ngModel)]="project.smartsheetWorkspace" name="smartsheetWorkspace" type="text" placeholder="Click &quot;Search&quot;" readonly>
              <div class="input-group-append">
                <button class="btn btn-outline-secondary rounded-right" type="button" (click)="promptUserForSmartsheetWorkspaceId()">Search</button>
              </div>
              <validation-error-display [error]="error" field="smartsheetWorkspace"></validation-error-display>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-12">
            <label for="smartsheetUrl">Smartsheet Dashboard Embed URL</label>
            <input class="form-control" id="smartsheetUrl" [(ngModel)]="project.smartsheetUrl" name="smartsheetUrl" type="text" maxlength="300">
            <validation-error-display [error]="error" field="smartsheetUrl"></validation-error-display>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-6">
            <label for="partnerPurchaseOrders">Partner Purchase Orders</label><span> (Add 1 per Line)</span>
            <textarea class="form-control" id="partnerPurchaseOrders" [(ngModel)]="partnerPurchaseOrders" name="partnerPurchaseOrders" rows="3"></textarea>
            <validation-error-display [error]="error" field="partnerPurchaseOrders"></validation-error-display>
          </div>
          <div class="form-group col-lg-6">
            <label for="partnerPurchaseOrders">Delivery Instructions For Every HWO</label>
            <textarea class="form-control" id="deliveryInformation" [(ngModel)]="project.deliveryInformation" name="deliveryInformation" rows="3"></textarea>
            <validation-error-display [error]="error" field="deliveryInformation"></validation-error-display>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Fill out quality checklist:</p>
      </div>
    </div>
  </div>
  <div class="row justify-content-md-center" *ngIf="project">
    <div class="col-md-10 card-block">
      <h5>Installation Quality Checklist</h5>
      <list-display [listStructure]="qualityChecklistData"></list-display>
    </div>
  </div>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Enter installation instructions:</p>
      </div>
    </div>
  </div>
  <div class="row justify-content-md-center">
    <div class="col-md-10 card-block">
      <div class="row">
        <div class="col-md-6">
          <h5>MAI Installation Instructions</h5>
          <list-display [listStructure]="maiInstructionsData"></list-display>
        </div>
        <div class="col-md-6">
          <h5>Lease Installation Instructions</h5>
          <list-display [listStructure]="leaseInstructionsData"></list-display>
        </div>
      </div>
    </div>
  </div>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Enter Dashboard data:</p>
      </div>
    </div>
  </div>
  <div class="row justify-content-md-center">
    <div class="col-md-10 card-block">
      <h5>Dashboard Milestones</h5>
      <list-display [listStructure]="milestoneData"></list-display>
      <h5 class="mt-4">Dashboard Issues</h5>
      <list-display [listStructure]="dashboardIssueData"></list-display>
    </div>
  </div>
</div>